exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lines .line.bold[data-v-5d6ac280] {\n  font-weight: bold;\n}\n.lines .line .name[data-v-5d6ac280] {\n  -ms-flex: 0 0 50% !important;\n      flex: 0 0 50% !important;\n}\n.lines .line .revenue[data-v-5d6ac280] {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  text-align: right !important;\n}\n.lines .line .coverage[data-v-5d6ac280] {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  text-align: right !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-5d6ac280","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/economy/learning/revenueAndCosts.vue
// module id = 573
// module chunks = 0